module.exports = __webpack_public_path__ + "static/img/white-2.fa70ca59.png";